
export const openGoogleMapsUtil = ({
    pickUpLat,
    pickUpLng,
    deliveryLat,
    deliveryLng,
  }: {
    pickUpLat?: string;
    pickUpLng?: string;
    deliveryLat?: string;
    deliveryLng?: string;
  }) => {
    const googleMapsUrl = `https://www.google.com/maps/dir/?api=1&origin=${pickUpLat},${pickUpLng}&destination=${deliveryLat},${deliveryLng}`;
    window.open(googleMapsUrl, "_blank");
  };